import Vue from 'vue';
import {
    DialogLayout,
    TableLayout,
    TableColumn,
    TableOperatorButton,
    TableOperatorSearch,
    TableFilterRadio,
    UploadImage,
    UploadProcess
} from '@isyscore/admin-ui';

[
    DialogLayout,
    TableLayout,
    TableColumn,
    TableOperatorButton,
    TableOperatorSearch,
    TableFilterRadio,
    UploadImage,
    UploadProcess
].forEach((comp) => Vue.use(comp));
